import axios from "axios";
import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom"
import { BreadCrumbType, BreadcrumbTypes } from "../../../models/breadcrumb-model";
import { retrieveBreadcrumb } from "../../../redux/slice/breadcrumb-slice";
import { RootState, useAppDispatch } from "../../../redux/store";


const Breadcrumbs = (props: {breadcrumbPath: string}) => {
    const location = useLocation()
    const websiteLink = location.pathname.split('/')[1] 
    const websitePage = 'website'

    const dispatch = useAppDispatch()
    const {BreadcrumbData} = useSelector((state: RootState) => state.breadcrumb)
    
    useEffect(() => {
        dispatch(retrieveBreadcrumb(props.breadcrumbPath));       
     }, [dispatch, props.breadcrumbPath])
     
    return <div className="breadcrumb">
        <Link to="/">Home</Link> 
        {
            

            BreadcrumbData[0]?.data.map((linkItem, index) => {
            return ((BreadcrumbData[0]?.data.length - 1) > index) ? (
                <React.Fragment key={index}>
                   
                    {' > '}<Nav.Link  href={
                        websiteLink === websitePage ? '#' : linkItem.nodeAliasPath.toLowerCase()
                    }
                    >{` ${linkItem.pageName}`}</Nav.Link>
                </React.Fragment>
                
            ): (
                <React.Fragment key={index}>
                   {' > '}<span key={index} className="CMSBreadCrumbsCurrentItem">{`${linkItem.pageName}`}</span>
                </React.Fragment>
                
            )
           })
        }
        </div>
}

export default Breadcrumbs;